export default "__VITE_ASSET__C9tQZD3___"